define([
    'system/domain/action/tag',
    'system/domain/entity/tag',
    'system/domain/collection/tag',
    'common/ui/view/material-color-palette',
    'system/ui/template/tag/create-modal.hbs',
    'common/util',
    'common/util/logger',
    'i18next',
    'backbone.marionette',
    'backbone.stickit',
    'bootstrap'
], function(
    TagActionCreator,
    TagModel,
    TagCollection,
    ColorPaletteView,
    TagCreateViewTemplate,
    Util,
    Logger,
    i18n,
    Mn
    ){

    return Mn.View.extend({
        model: TagModel,
        collection: TagCollection,
        tagName: 'div',
        className: 'tag-create',
        template: TagCreateViewTemplate,
        ui: {
            category: '.is-category input',
            exposed: '.is-exposed',
            color: '.color',
            colorSelectedGroup: '.color-selected-group',
            colorSelected: '.color-selected',
            alertMessage: '.alert-message'
        },
        events: {
            'click .save': 'save',
            'click .cancel': 'remove',
            'click .close': 'remove',
            'change @ui.category': 'category'
        },
        regions: {
            palette: '.color-palette'
        },

        bindings: {
            'input.name': 'name',
            'input.is-exposed': 'exposed'
        },

        initialize: function() {
            _.bindAll(this, 'save', 'success', 'show', 'hide', 'onShow');
            this._context = this.getOption('context');
            this.model = new Backbone.Model();
            this.model.set('id', Util.generateId());
            this.$el.on('shown.bs.modal', this.onShow);
        },

        onRender: function() {
            this.stickit();

            this.paletteView = new ColorPaletteView();
            this.showChildView('palette', this.paletteView);
            this.listenTo(this.paletteView, 'selected',
                function(color) {
                    this.model.set('color', color);
                    this.ui.colorSelected.css('background-color', color);
            });

            return this;
        },

        onShow: function() {
            this.paletteView.select();
        },

        category: function() {
            var checked = this.ui.category.prop('checked');
            this.model.set('is_category', checked);
            if(checked) {
                this.ui.exposed.show();
                this.ui.color.hide();
                this.ui.colorSelectedGroup.hide();
            } else {
                this.ui.exposed.hide();
                this.ui.color.show();
                this.ui.colorSelectedGroup.show();
            }
        },

        show: function() {
            this.$('div.modal').modal('show');
        },

        hide: function() {
            this.$('div.modal').modal('hide');
        },

        _validate: function() {
            // 空のタグを弾く
            if(this.model.get('name').length == 0) {
                this.ui.alertMessage.html(i18n.t('model:tag.errors.emptyName'));
                return false;
            }

            return true;
        },

        save: function() {
            if(!this._validate()) {
                return;
            }
            var deferred = null;
            if(this.model.get('is_category')){
                var j = {
                    id: this.model.id,
                    name: this.model.get('name'),
                    exposed: this.model.get('exposed')
                };
                deferred = TagActionCreator.createCategory(
                    this._context.projectId, j.id, j
                );
            } else {
                var j = {
                    id: this.model.id,
                    name: this.model.get('name'),
                    color: this.model.get('color')
                };
                deferred = TagActionCreator.createTag(
                    this._context.projectId, j.id, j);
            }
            deferred.then(this.success);
        },

        success: function(model) {
            Logger.info("Tag create success", model);
            this.remove();
        }

    });
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/tag-create.js